import {handleActions} from 'redux-actions'
import {
  updateUrlQuery,
  updateAllowedDomains,
  updateAllowedSchemas,
  updateVariations,
  showSnackbar,
  throwError
} from './actions'

export const initialState = {
  allowedDomains: null,
  urlQuery: null,
  variations: null,
  snackbar: {
    message: null,
    type: null
  }
}

export default handleActions(
  {
    [updateUrlQuery](state, {payload}) {
      return {
        ...state,
        urlQuery: payload
      }
    },

    [updateAllowedDomains](state, {payload}) {
      return {
        ...state,
        allowedDomains: payload
      }
    },

    [updateAllowedSchemas](state, {payload}) {
      return {
        ...state,
        allowedSchemas: payload
      }
    },

    [updateVariations](state, {payload}) {
      return {
        ...state,
        variations: payload
      }
    },

    [showSnackbar](state, {payload, meta}) {
      return {
        ...state,
        snackbar: {
          message: payload,
          type: (meta && meta.type) || 'success',
          autoCloseDuration: (meta && meta.autoCloseDuration) || 4000
        }
      }
    },

    [throwError](state, {payload, meta}) {
      let message = payload

      const copyable = Boolean(
        meta &&
          meta.details &&
          (meta.details.errorContextToken || meta.details.currentThreadExtra)
      )

      if (copyable) {
        message += `${
          /[,.!?]$/.test(payload) ? '' : '.'
        } Скопируйте информацию ниже и обратитесь с ней в службу поддержки:\n\nИдентификатор ${
          meta.details.errorContextToken ? 'ошибки' : 'потока'
        }: ${
          meta.details.errorContextToken || meta.details.currentThreadExtra
        }. Ваш браузер: ${
          window.navigator.userAgent
        }. Время: ${new Date().toUTCString()}.`
      }

      return {
        ...state,
        snackbar: {
          message,
          type: copyable ? 'main' : 'danger',
          autoCloseDuration: 10000,
          copyable
        }
      }
    }
  },
  initialState
)
